import { Component, computed, inject, signal } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive, Router, NavigationEnd } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

import defaultTranslations from '../../public/i18n/en.json';
import { PrimeNG } from 'primeng/config';
import { ApiService } from './api.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, TranslatePipe, RouterLink, RouterLinkActive, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private primeng = inject(PrimeNG);
  private translate = inject(TranslateService);
  public api = inject(ApiService);
  private router = inject(Router);

  hideHeader = signal(false);
  hideFooter = signal(false);

  gridRows = computed(() => {
    let height = 0;
    let headerHeight = "";
    let footerHeight = "";

    if (!this.hideHeader()) {
      height += 96;
      headerHeight = "96px";
    }

    if (!this.hideFooter()) {
      let footerSetHeight = 64;
      if (window.innerWidth <= 750) {
        footerSetHeight = 128;
      }

      height += 64;
      footerHeight = footerSetHeight + "px";
    }

    if (height == 0) {
      return "100%";
    } else {
      return [headerHeight, "calc(100% - " + height + "px)", footerHeight].join(" ");
    }
  });

  menuLinks = [
    { route: '/home', label: 'mainmenu.home' },
    { route: '/gallery', label: 'mainmenu.gallery' },
    { route: '/internal', label: 'mainmenu.internal' },
  ];

  footerLinks = [
    { route: '/impressum', label: 'footer.impressum' },
    { route: 'https://www.fanny-leicht.de', label: 'footer.flg', external: true },
    { route: 'https://www.instagram.com/technikflg/', label: 'footer.instagram', external: true },
  ];

  get currentYear() {
    return new Date().getFullYear();
  }

  constructor() {
    this.translate.setTranslation('en', defaultTranslations);
    this.translate.setFallbackLang('en');

    this.translate.use(navigator.language.slice(0, navigator.language.indexOf('-'))).subscribe({
      next: () => console.log('Language File loaded'),
      error: (err) => {
        console.error('Language file could not be found: ', err);
      },
    });

    this.translate.get("primeng").subscribe(res => this.primeng.setTranslation(res));
  }

  ngOnInit() {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        var snapshot = this.router.routerState.root.firstChild.snapshot;
        var params = snapshot.data;

        console.log(params);

        this.hideHeader.set(params['hideHeader'] ?? false);
        this.hideFooter.set(params['hideFooter'] ?? false);
      }
    });
  }
}
